/*eslint object-property-newline: ["error", { "allowAllPropertiesOnSameLine": true }]*/
import React, { PureComponent } from "react";
import {
    number,
    string,
    bool,
    shape,
    array,
    func,
    object,
    oneOfType,
    any
} from "prop-types";
import util from "../../../util";
import SpecialPrice from "./SpecialPrice";
import Image from "../Components/Image";
import he from "he";
import moment from "moment";
import TrackVisibility from "react-on-screen";
import withDataLayer from "./../HOCs/withDataLayer";

const CONDITIONS = {
    467: "Used",
    468: "New",
    469: "Refurbished",
    470: "For Parts/Not Working",
    488: "Not Specified"
};
const ANNOUNCEMENT_TYPE_ID = 6102;

class CatalogItem extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            isMounted: false
        };

        this.itemOnClick = this.itemOnClick.bind(this);
        this.onImpression = this.onImpression.bind(this);
        this.ProductLabel = this.ProductLabel.bind(this);
        this.handleImageError = this.handleImageError.bind(this);

        this.count = 0;
    }

    componentDidMount() {
        this.setState({
            isMounted: true
        });
    }

    render() {
        this.count = 0;
        let {
            restUrl,
            hover,
            id,
            product_id,
            sku,
            small_image,
            name,
            showSku,
            condition,
            price,
            special_price,
            quote_status,
            seller_name,
            show_seller,
            ebay_location_state,
            ebay_location_country,
            view,
            description,
            trackImpressions,
            children
        } = this.props;

        const itemLink = `/item/${util.convertToUrlKey(name)}/${sku}`;

        name = name ? he.decode(name) : "Not Specified";
        const itemSrc =
            small_image !== "no_selection" && this.state.isMounted
                ? `${restUrl}/pub/media/catalog/product/${
                    product_id ? product_id : id
                }/small_image${small_image}`
                : null;

        if (description) {
            description = description.replace(
                /(<script(\s|\S)*?<\/script>)|(<style(\s|\S)*?<\/style>)|(<!--(\s|\S)*?-->)|(<\/?(\s|\S)*?>)/g,
                ""
            );
            description = description.replace(/(&)([A-z]+)(;)/g, "");
        }

        return (
            <div
                key="catalog-item"
                className="product-card"
                onClick={this.itemOnClick}
                title={`${seller_name ? `${seller_name}: ` : ""}${
                    ebay_location_state ? `${ebay_location_state}, ` : ""
                }${ebay_location_country ? `${ebay_location_country}` : ""}`}>
                {trackImpressions && (
                    <TrackVisibility style={{ height: 0, width: 0 }} once>
                        {({ isVisible }) => isVisible && this.onImpression()}
                    </TrackVisibility>
                )}
                <div className={`card ${hover ? "card-hover" : ""}`}>
                    <div className="card-img-top">
                        <a href={itemLink}>
                            {itemSrc && (
                                <Image
                                    src={itemSrc}
                                    onError={this.handleImageError}
                                    className="responsive"
                                    alt={name}
                                />
                            )}
                            {this.ProductLabel()}
                        </a>
                    </div>
                    <div className="card-body">
                        <a href={itemLink} className="card-title">
                            {name}
                        </a>
                        {showSku && <p className="text-muted">{sku}</p>}
                        <SpecialPrice
                            price={price}
                            specialPrice={special_price ? special_price.replace(/[$]/gi, "") : false}
                            buyNow={quote_status === "0" ? true : false}
                        />
                        {show_seller && seller_name ? (
                            <p className="text-left">{seller_name}</p>
                        ) : (
                            condition && (
                                <p className="text-left">
                                    Condition: {CONDITIONS[condition]}
                                </p>
                            )
                        )}
                        {description && view && view === "list" && (
                            <p className="item-description">
                                {description.substring(0, 200)}
                                {description.length > 200 && "..."}
                            </p>
                        )}
                        {children}
                    </div>
                </div>
            </div>
        );
    }

    handleImageError(e) {
        let { restUrl, image } = this.props;

        let fallBackImages = [
            `${restUrl}/pub/media/catalog/product${image}`,
            "/images/image-not-found.png"
        ];

        e.target.src = fallBackImages[this.count];
        this.count++;
    }

    itemOnClick() {
        let {
            trackClicks,
            seller_id,
            price,
            manufacturer_name,
            model,
            name,
            sku,
            featured_start_date,
            featured_end_date,
            product_id,
            actionField,
            category_names = [],
            positionIndex
        } = this.props;

        name = he.decode(name);

        if (trackClicks && window.dataLayer) {
            if (
                featured_start_date &&
                featured_end_date &&
                moment().isBetween(
                    moment(featured_start_date),
                    moment(featured_end_date)
                )
            ) {
                this.props.pushDataLayer({
                    event: "Featured Product Click",
                    seller_id: seller_id,
                    price: price,
                    manufacturer_name: manufacturer_name,
                    model: model,
                    headline: name,
                    adNo: sku
                });
            } else {
                const pushEvent = {
                    event: "productClick",
                    ecommerce: {
                        click: {
                            actionField: { list: actionField || "category" },
                            products: [{
                                name: name,
                                id: product_id,
                                price: price || null,
                                brand: manufacturer_name || null,
                                category: category_names.length > 0
                                    ? category_names[0]
                                    : null,
                                seller_id: seller_id,
                                adNo: sku,
                                position: positionIndex
                            }]
                        }
                    }
                };

                this.props.pushDataLayer(pushEvent);
            }
        }
    }

    onImpression() {
        let {
            trackImpressions,
            name,
            sku,
            seller_id,
            price,
            model,
            manufacturer_name,
            featured_end_date,
            featured_start_date
        } = this.props;

        name = he.decode(name);

        if (trackImpressions && window.dataLayer) {
            if (
                featured_start_date &&
                featured_end_date &&
                moment().isBetween(
                    moment(featured_start_date),
                    moment(featured_end_date)
                )
            ) {
                this.props.pushDataLayer({
                    event: "Featured Product Impression",
                    seller_id: seller_id,
                    price: price,
                    manufacturer_name: manufacturer_name,
                    model: model,
                    headline: name,
                    adNo: sku
                });
            }
        }
    }

    ProductLabel() {
        let { featured_type } = this.props;

        if (featured_type && featured_type.includes(ANNOUNCEMENT_TYPE_ID)) {
            return <span className="announcement-label">Announcement</span>;
        } else {
            return null;
        }
    }
}

export default withDataLayer(CatalogItem);

CatalogItem.defaultProps = {
    price: 0,
    restUrl: process.env.REST_URL
        ? process.env.REST_URL
        : localStorage.getItem("restUrl"),
    condition: 488,
    hover: true,
    show_seller: false,
    trackImpressions: false,
    trackClicks: false
};

CatalogItem.propTypes = {
    id: oneOfType([number, string]),
    product_id: string,
    name: string.isRequired,
    sku: string.isRequired,
    showSku: bool,
    image: string,
    thumbnail: string,
    small_image: string,
    price: oneOfType([number, string]),
    condition: oneOfType([number, string]),
    extension_attributes: shape({
        badges: array
    }),
    has_badges: bool,
    badge_object: object,
    featured_type: string,
    children: any,
    restUrl: string,
    special_price: oneOfType([number, string]),
    quote_status: oneOfType([number, string]),
    ebay_location_state: string,
    ebay_location_country: string,
    hover: bool,
    seller_id: oneOfType([number, string]),
    manufacturer_name: string,
    model: string,
    featured_start_date: string,
    featured_end_date: string,
    trackImpressions: bool,
    trackClicks: bool,
    actionField: string,
    positionIndex: number,
    category_names: array,
    seller_name: string,
    show_seller: bool,
    pushDataLayer: func,
    view: string,
    description: string
};
